import classNames from 'classnames';
import { FC, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import {
  getDeviceDetails
} from 'src/store/actions/deviceActions';
import { TicketStatus } from 'src/store/models/Ticket';
import { useLoadingSelector } from 'src/utils/useLoadingSelector';

import Fans from '../Fans/Fans';
import ShadowBox from '../ShadowBox/ShadowBox';
import classes from './HeatingApplianceDetails.module.scss';
import SensorData from './SensorData/SensorData';
import ServiceInfo from './ServiceInfo/ServiceInfo';

const HeatingApplianceDetails: FC = () => {
  const dispatch = useAppDispatch();

  const loading = useLoadingSelector({
    actionType: getDeviceDetails.toString(),
  });
  const ticketDetails = useAppSelector((state) => state.ticket.ticketDetails);
  const deviceDetails = useAppSelector((state) => state.device.deviceDetails);

  useEffect(() => {
    let interval: NodeJS.Timer;
    if (ticketDetails?.unitId) {
      const getDetails = (refresh: boolean) => {
        dispatch(getDeviceDetails({ unitId: ticketDetails?.unitId, refresh }));
      };

      getDetails(false);
      interval = setInterval(() => {
        getDetails(true);
      }, 60000);
    }

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [ticketDetails]);

  return (
    <ShadowBox
      className={classNames(classes.Container, {
        [classes.Disconnected]: !deviceDetails,
      })}
    >
      <section>
        <ServiceInfo
          loading={loading}
          deviceDetails={
            ticketDetails?.status === TicketStatus.IN_PROGRESS && deviceDetails
          }
        />
      </section>
      <div className={classes.Divider} />
      <section>
        <SensorData
          loading={loading}
          deviceDetails={
            ticketDetails?.status === TicketStatus.IN_PROGRESS && deviceDetails
          }
        />
      </section>
      <div className={classes.Divider} />
      <section>
        <Fans
          loading={loading}
          disabled={ticketDetails?.status !== TicketStatus.IN_PROGRESS}
        />
      </section>
    </ShadowBox>
  );
};

export default HeatingApplianceDetails;
